import styled from 'styled-components';

export const SelectorContainer = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: ${({ $fillViewport }) => ($fillViewport ? '0' : '24px')};
    min-width: 0;
    width: 100%;
    max-width: min(800px, 100%);
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;

    ${({ $fillViewport }) =>
        $fillViewport &&
        `
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    `}
`;

export const SelectorHeader = styled.div`
    padding: clamp(12px, 2.5vw, 16px) clamp(16px, 3vw, 24px);
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};
    flex-shrink: 0;
`;

export const SelectorTitle = styled.h3`
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const SelectorContent = styled.div`
    padding: clamp(12px, 2.5vw, 20px);
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;

    ${({ $fillViewport }) =>
        $fillViewport &&
        `
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    `}
`;

export const SelectorOptions = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));
    gap: 16px;
    margin-bottom: 16px;
    flex-shrink: 0;
`;

export const OptionButton = styled.button`
    padding: 16px;
    background: ${({ $active, theme }) =>
        $active ? theme.colors.primary.light + '10' : '#ffffff'};
    color: ${({ $active, theme }) =>
        $active ? theme.colors.primary.main : theme.colors.gray[900]};
    border: 2px solid ${({ $active, theme }) =>
        $active ? theme.colors.primary.main : theme.colors.gray[200]};
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;

    &:hover {
        border-color: ${({ theme }) => theme.colors.primary.main};
        background: ${({ theme }) => theme.colors.primary.light + '10'};
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const OptionLabel = styled.span`
    font-size: 14px;
    font-weight: 600;
`;

export const OptionDescription = styled.span`
    font-size: 12px;
    opacity: 0.7;
`;

/** Dois botões PJ | PF no mesmo espaço do antigo "Cliente". */
export const ClientOptionSplit = styled.div`
    display: flex;
    min-height: 100%;
    min-width: 0;
    border-radius: 8px;
    overflow: hidden;
    border: 2px solid
        ${({ $active, theme }) => ($active ? theme.colors.primary.main : theme.colors.gray[200])};
    box-sizing: border-box;

    ${({ $compact }) =>
        $compact &&
        `
        margin-bottom: 12px;
        max-width: 100%;
    `}
`;

export const ClientHalfButton = styled.button`
    flex: 1;
    min-width: 0;
    padding: ${({ $compact }) => ($compact ? '10px 8px' : '16px 10px')};
    background: ${({ $active, theme }) =>
        $active ? theme.colors.primary.light + '10' : '#ffffff'};
    color: ${({ $active, theme }) =>
        $active ? theme.colors.primary.main : theme.colors.gray[900]};
    border: none;
    font-size: ${({ $compact }) => ($compact ? '13px' : '14px')};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ $compact }) => ($compact ? '4px' : '8px')};
    text-align: center;

    &:not(:last-child) {
        border-right: 1px solid ${({ theme }) => theme.colors.gray[200]};
    }

    &:hover {
        background: ${({ theme }) => theme.colors.primary.light + '10'};
        color: ${({ theme }) => theme.colors.primary.main};
    }

    svg {
        width: ${({ $compact }) => ($compact ? '20px' : '24px')};
        height: ${({ $compact }) => ($compact ? '20px' : '24px')};
        flex-shrink: 0;
    }

    ${OptionDescription} {
        display: ${({ $compact }) => ($compact ? 'none' : 'block')};
    }
`;

export const CustomerTableWrapper = styled.div`
    margin-top: 20px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
`;

/** Listagem de clientes no seletor (scroll na tabela; paginação fixa abaixo). */
export const CustomerSelectorListArea = styled.div`
    margin-top: ${({ $compactTop }) => ($compactTop ? '0' : '12px')};
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const InfoBadge = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: ${({ theme }) => theme.colors.primary.light}15;
    border-radius: 6px;
    margin-top: 12px;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.primary.main};
    font-size: 14px;
    font-weight: 500;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const CollapsedContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    color: ${({ theme }) => theme.colors.gray[900]};
    font-weight: 500;
    font-size: 14px;

    svg {
        width: 20px;
        height: 20px;
        color: ${({ theme }) => theme.colors.primary.main};
    }

    strong {
        color: ${({ theme }) => theme.colors.primary.main};
    }
`;

export const ChangeButton = styled.button`
    background: transparent;
    border: 1px solid ${({ theme }) => theme.colors.gray[300]};
    color: ${({ theme }) => theme.colors.gray[600]};
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
        border-color: ${({ theme }) => theme.colors.gray[400]};
    }
`;

// Estilos para o estado minimizado
export const CollapsedContainer = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    transition: all 0.2s ease;

    &:hover {
        border-color: ${({ theme }) => theme.colors.primary.main};
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;

        ${ChangeButton} {
            width: 100%;
            padding: 10px;
        }
    }
`;

export const SearchBar = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    min-width: 0;
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    border-radius: 4px;
    margin-bottom: 16px;

    svg {
        width: 20px;
        height: 20px;
        color: ${({ theme }) => theme.colors.gray[600]};
    }
`;

export const SearchInput = styled.input`
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[900]};

    &::placeholder {
        color: ${({ theme }) => theme.colors.gray[400]};
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;
    border-radius: 4px;
    min-width: 600px;
`;

export const TableHeader = styled.th`
    text-align: left;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray[900]};
    background: ${({ theme }) => theme.colors.background};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};
`;

export const TableRow = styled.tr`
    transition: background-color 0.2s ease;

    ${({ $isHeader }) => !$isHeader && `
        &:hover {
            background-color: #f8f9fa;
        }
    `}

    ${({ $selected, theme }) => $selected && `
        background-color: ${theme.colors.primary.light}10;
    `}

    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};

    &:last-child {
        border-bottom: none;
    }
`;

export const TableCell = styled.td`
    padding: 12px 16px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[900]};
`;

export const SelectButton = styled.button`
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;

    ${({ $selected, theme }) => $selected ? `
        background: ${theme.colors.primary.main};
        color: #ffffff;
        cursor: default;
    ` : `
        background: #ffffff;
        color: ${theme.colors.primary.main};
        border: 1px solid ${theme.colors.primary.main};

        &:hover {
            background: ${theme.colors.primary.light}10;
        }
    `}
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px;
    background: #ffffff;
    border-top: 1px solid ${({ theme }) => theme.colors.gray[100]};
    margin-top: 0;
`;

export const PageInfo = styled.span`
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 14px;
`;

export const PageButtons = styled.div`
    display: flex;
    gap: 8px;
`;

/** Badge de status cadastral (CustomerHeader / RegistrationStatusEnum). */
export const RegistrationStatusBadge = styled.span`
    display: inline-block;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({ $status }) => {
        const s = String($status ?? '')
            .trim()
            .toUpperCase();
        if (s === 'ACTIVE') {
            return `
                background: #ecfdf5;
                color: #047857;
                border: 1px solid #a7f3d0;
            `;
        }
        if (s === 'SUSPENDED') {
            return `
                background: #fffbeb;
                color: #b45309;
                border: 1px solid #fde68a;
            `;
        }
        if (s === 'UNFIT' || s === 'CLOSED' || s === 'NULL') {
            return `
                background: #fef2f2;
                color: #b91c1c;
                border: 1px solid #fecaca;
            `;
        }
        return `
            background: #f4f4f5;
            color: #52525b;
            border: 1px solid #e4e4e7;
        `;
    }}
`;


